module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/root//pet-effect_base_1.png?v=cf5599f9";